export const MAIN_SECTION = {
    backgroundColor: "white",
    borderRadius: 3,
    border: "1px solid #ddd",
    boxShadow: "0 0 5px rgba(0,0,0,0.1)",
    color: "#28313E",
    margin: "0 auto"
};

export const MAIN_CONTENT = Object.assign({}, MAIN_SECTION, {
    maxWidth: 680,
    marginTop: -40
});



/** WEBPACK FOOTER **
 ** ./src/main/javascript/styles.js
 **/